var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.urls),function(url){return _c('el-image',{key:url,attrs:{"src":url}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }